export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-m@3x.a68f96e5.png";